import React from 'react';
import PropTypes from 'prop-types';
import BasketDialogBoxContentBody from '../../../general/js/basket/basket-dialog-box-content-body';
import userService from '../../../general/js/user/user-service';
import ConfirmationModal from '../../sso/components/common/utility/ConfirmationModal';
import { BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME } from '../../../general/js/user/constants';

export default class BasketPayButtons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
        this.toggleCloseModal = this.toggleCloseModal.bind(this);
    }

    toggleConfirmationModal() {
        userService.removeDataCookie(BALLOT_ORDER_FILE_NUMBER_COOKIE_NAME);
        if (this.props.showAlertBoxBeforePayment) {
            this.setState({ showModal: true });
        } else {
            this.setState({ showModal: false });
            this.props.onCheckout();
        }
    }

    toggleCloseModal() {
        this.setState({ showModal: false });
    }

    render() {
        return (
            <React.Fragment>
                <div className="basket__pay-buttons">
                    <button onClick={this.toggleConfirmationModal}
                        className="basket__pay-button button button--super">
                        <span className="button-content button-content--icon">
                            <span>Pay</span>
                            <svg className="icon button__arrow-left" width="14" height="12" focusable="false">
                                <use xlinkHref="#icon-arrow-right" />
                            </svg>
                        </span>
                    </button>
                    <div className="throttle">
                        <span>We are experiencing high volumes of traffic at the minute. Please try again.</span>
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={this.state.showModal}
                    inputText={'Pay'}
                    onModalClose={this.toggleCloseModal}
                    onApproveClick={() => this.props.onCheckout()}
                    isApproveDanger={false}
                    isApproveButtonDisabled={false}
                    onCancelClick={this.toggleCloseModal}
                    isCancelButtonDisabled={true}
                    masterCardDialogBoxBanner={this.props.dialogBoxBanner}
                >
                    <BasketDialogBoxContentBody
                        basketDialogBoxTitle={this.props.dialogBoxTitle}
                        basketDialogBoxMessage={this.props.dialogBoxMessage}
                        basketDialogBoxLogo={this.props.dialogBoxLogo}>
                    </BasketDialogBoxContentBody>
                </ConfirmationModal>
            </React.Fragment>
        );
    }
}

BasketPayButtons.propTypes = {
    basket: PropTypes.object.isRequired,
    onCheckout: PropTypes.func.isRequired,
    showAlertBoxBeforePayment: PropTypes.bool.isRequired,
    dialogBoxTitle: PropTypes.string,
    dialogBoxMessage: PropTypes.string,
    dialogBoxLogo: PropTypes.string
};
